const getLotBuyers = (firstBuyer?: string, secondBuyer?: string) => {
  if (firstBuyer && !secondBuyer) return firstBuyer;

  if (!firstBuyer && secondBuyer) return secondBuyer;

  if (firstBuyer && secondBuyer) return `${firstBuyer}, ${secondBuyer}`;

  return "N/A";
};

export default getLotBuyers;
